import { SAddLegacyContactModal, SDescriptionRow, SModalTitleRow } from './ContactAddModal.styled'
import { ContactCreateForm } from 'components/contact/contactCreateForm/ContactCreateForm'
import { useContactInfoModal } from 'components/contact/contactInfoModal/ContactInfoModal'
import { Icon } from 'components/icon'
import { Text, Title } from 'components/Typography'
import React from 'react'
import { colors } from 'utils/colors'
import { ApiType } from 'utils/types'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'

export const ContactAddModal = (props: {
  onSuccess?: (data?: ApiType['TrustedContactResponse']) => void
  isLegacy?: boolean
}) => {
  const { t } = useDynamicTranslations('dashboard')
  const [infoModal, openInfoModal] = useContactInfoModal(props.isLegacy)

  return (
    <SAddLegacyContactModal>
      {infoModal}
      <SModalTitleRow>
        <Icon name="PersonAdd" />
        <Title variant="h7" as="h5">
          {props.isLegacy
            ? t('dashboard.todos.legacy_contact.add_title_legacy')
            : t('dashboard.todos.legacy_contact.add_title_trusted')}
        </Title>
      </SModalTitleRow>
      <SDescriptionRow>
        <Text>{t('dashboard.todos.legacy_contact.add_contact_text')}</Text>
        <Icon name="Question" size="2rem" color={colors.gray[500]} onClick={openInfoModal} />
      </SDescriptionRow>

      <ContactCreateForm {...props} />
    </SAddLegacyContactModal>
  )
}
